__webpack_require__.p = "https://beta.addapt.fintech.amazon.dev/";